<template>
  <div>
    <el-row :gutter="10">
      <el-col :lg="12" :md="24">
        <el-card class="box-card" ref="card">
          <div slot="header" class="clearfix">
              <span>广告主类型 <span style="font-weight: lighter;font-size: 10px">（{{
                  condition.year
                }}年{{ condition.month }}月
                <el-tooltip class="item" effect="dark"
                            :content="`统计数据来源：${condition.year}年${condition.month}月内下单的订单`"
                            placement="top-start">
                        <i class="el-icon-info" style="cursor: pointer;color: #8a8e99"/>
                </el-tooltip>）</span></span>
            <el-link style="float: right; padding: 3px 0;margin-left: 10px" type="primary" :underline="false"
                     title="点击刷新"
                     @click="getData"><i class="el-icon-refresh-right"/></el-link>
            <el-button style="float: right; margin-left: 10px;" size="mini" type="primary" plain icon="el-icon-upload2"
                       @click="openSyncDialog('order_source')" v-permission="'dashboard_btn_sync_fs'">同步到飞书</el-button>
            <summary-export-link filename="广告主类型" :params="{...{tag: 'orderSource'},...condition}"/>
          </div>
          <el-table class="dashboard-table"
                    show-summary
                    :summary-method="getSummaries"
                    :data="dataOrderSource"
                    @sort-change="sortOrderSourceChange"
                    :row-style="{ border: 'none',padding:'15px 0'}"
                    :cell-style="{ border: 'none'}"
          >
            <el-table-column prop="name" label="订单来源"/>
            <el-table-column prop="order_money" :label="`订单总额\u2002(元)\u2002\u2002\u2002`" align="right"
                             :sortable="'custom'">
              <template slot-scope="scope">
                <span class="money">{{ gFunc.numberFormat(scope.row.order_money) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="order_count" label="订单总数" align="right" :sortable="'custom'"/>
            <el-table-column prop="customer_count" :label="`客户总数\u2002(个)\u2002\u2002\u2002`" align="right"
                             :sortable="'custom'"/>
            <el-table-column prop="customer_percent_count" :label="`客户占比`" align="right">
              <template slot-scope="scope">
                <span class="rate">{{ scope.row.customer_percent_count }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="order_percent_money" :label="`金额占比`" align="right">
              <template slot-scope="scope">
                <span class="rate">{{ scope.row.order_percent_money }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="order_percent_count" :label="`单量占比`" align="right">
              <template slot-scope="scope">
                <span class="rate">{{ scope.row.order_percent_count }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :lg="12" :md="24">
        <el-card class="box-card" ref="card">
          <div slot="header" class="clearfix">
              <span>合作形式<span style="font-weight: lighter;font-size: 10px">（{{ condition.year }}年{{
                  condition.month
                }}月
                <el-tooltip class="item" effect="dark"
                            :content="`统计数据来源：${condition.year}年${condition.month}月内下单的订单`"
                            placement="top-start">
                        <i class="el-icon-info" style="cursor: pointer;color: #8a8e99"/>
                </el-tooltip>
                ）</span></span>
            <el-link style="float: right; padding: 3px 0;margin-left: 10px" type="primary" :underline="false"
                     title="点击刷新"
                     @click="getData"><i class="el-icon-refresh-right"/></el-link>
            <el-button style="float: right; margin-left: 10px;" size="mini" type="primary" plain icon="el-icon-upload2"
                       @click="openSyncDialog('order_work_form')" v-permission="'dashboard_btn_sync_fs'">同步到飞书</el-button>
            <summary-export-link filename="合作形式" :params="{...{tag: 'orderWorkForm'},...condition}"/>
          </div>
          <el-table class="dashboard-table"
                    show-summary
                    :summary-method="getSummaries"
                    :data="dataOrderWorkForm"
                    @sort-change="sortOrderWorkFormChange"
                    :row-style="{ border: 'none',padding:'15px 0'}"
                    :cell-style="{ border: 'none'}"
          >
            <el-table-column prop="name" label="合作形式"/>
            <el-table-column prop="order_money" :label="`订单总额\u2002(元)\u2002\u2002\u2002`" align="right"
                             :sortable="'custom'">
              <template slot-scope="scope">
                <span class="money">{{ (scope.row.order_money) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="order_count" label="订单总数" align="right" :sortable="'custom'"/>
            <el-table-column prop="order_percent_money" :label="`金额占比`" align="right">
              <template slot-scope="scope">
                <span class="rate">{{ (scope.row.order_percent_money) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="order_percent_count" :label="`单量占比`" align="right">
              <template slot-scope="scope">
                <span class="rate">{{ (scope.row.order_percent_count) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog :title="`同步${syncScopeLabel}到飞书多维表格`" :visible.sync="dialogSyncVisible" width="760px"
               :close-on-click-modal="false" append-to-body>
      <div style="margin-bottom: 14px;color:#606266;font-size:13px;">
        将当前{{ condition.year }}年{{ condition.month }}月的「{{ syncScopeLabel }}」同步到飞书多维表格，每行写入一条记录。<br/>
        「月份」若选择「日期」类型，将按「年份 + 月份」写入日期（取当月 1 号）。
      </div>
      <el-form :model="syncForm" label-width="110px" label-position="right">
        <el-form-item label="多维表格 App Token">
          <el-input v-model="syncForm.app_token" placeholder="bascxxxxxxxxxx（必填）" clearable/>
        </el-form-item>
        <el-form-item label="数据表 ID">
          <div style="display: flex;align-items: center;">
            <el-input v-model="syncForm.table_id" placeholder="tblxxxxxxxxxx（必填）" clearable style="flex:1"/>
            <el-button style="margin-left: 8px;" size="mini" type="primary" plain icon="el-icon-plus"
                       @click="openCreateTableDialog">新增数据表</el-button>
          </div>
        </el-form-item>
        <el-form-item label="写入模式">
          <el-radio-group v-model="syncForm.mode">
            <el-radio label="append">追加（每次同步新增记录）</el-radio>
            <el-radio label="replace">覆盖（先清空目标表再写入）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="自定义字段">
          <el-table :data="syncForm.fields" size="mini" border>
            <el-table-column label="数据源字段" width="200">
              <template slot-scope="{row}">
                <span>{{ row.label }}</span>
              </template>
            </el-table-column>
            <el-table-column label="飞书列名" width="220">
              <template slot-scope="{row}">
                <el-input v-model="row.name" size="mini" placeholder="列名"/>
              </template>
            </el-table-column>
            <el-table-column label="类型" width="110">
              <template slot-scope="{row}">
                <el-select v-model="row.type" size="mini" style="width:100%">
                  <el-option v-for="opt in fieldTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value"/>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="同步" width="70" align="center">
              <template slot-scope="{row}">
                <el-switch v-model="row.enabled" size="mini"/>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 8px;">
            <el-button type="text" icon="el-icon-document-copy" style="color:#409EFF"
                       @click="copySyncFieldsAsBitableJson">复制为飞书JSON</el-button>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSyncVisible = false">取 消</el-button>
        <el-button @click="handleSaveSyncConfig">保存为全局默认</el-button>
        <el-button type="primary" :loading="syncLoading" @click="handleSyncData" v-permission="'dashboard_btn_sync_fs'">同步到飞书</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="`新增数据表（同步${syncScopeLabel}）`" :visible.sync="createTableVisible" width="620px"
               :close-on-click-modal="false" append-to-body>
      <div style="margin-bottom: 14px;color:#606266;font-size:13px;">
        在当前多维表格 App 内新建一个数据表，创建成功后会自动把数据表 ID 回填到上方「数据表 ID」。
      </div>
      <el-form :model="createTableForm" label-width="110px" label-position="right">
        <el-form-item label="多维表格 App Token">
          <el-input v-model="createTableForm.app_token" placeholder="bascxxxxxxxxxx（必填）" clearable/>
        </el-form-item>
        <el-form-item label="表名称">
          <el-input v-model="createTableForm.name" :placeholder="`数据表名称，如：${syncScopeLabel}`" clearable/>
        </el-form-item>
        <el-form-item label="默认视图名">
          <el-input v-model="createTableForm.default_view_name" placeholder="可选，如 表格视图" clearable/>
        </el-form-item>
        <el-form-item label="自定义字段">
          <el-table :data="createTableForm.fields" size="mini" border>
            <el-table-column label="字段名称">
              <template slot-scope="{row}">
                <el-input v-model="row.field_name" size="mini" placeholder="字段名称"/>
              </template>
            </el-table-column>
            <el-table-column label="类型" width="150">
              <template slot-scope="{row}">
                <el-select v-model="row.type" size="mini" style="width:100%">
                  <el-option v-for="opt in fieldTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value"/>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="70" align="center">
              <template slot-scope="{$index}">
                <el-button type="danger" icon="el-icon-delete" circle size="mini"
                           @click="removeCreateTableField($index)"/>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 8px;">
            <el-button type="text" icon="el-icon-document-add"
                       @click="createBatchJsonVisible = !createBatchJsonVisible">
              批量粘贴 JSON 生成字段
            </el-button>
            <el-input v-if="createBatchJsonVisible" v-model="createBatchJson" type="textarea" :rows="4"
                      placeholder='JSON 数组，每项生成一行字段，如 [{"field_name":"订单金额","type":2}]'/>
            <div v-if="createBatchJsonVisible" style="margin-top: 6px;">
              <el-button size="mini" type="primary" @click="applyCreateBatchJson">生成字段</el-button>
            </div>
          </div>
          <el-button style="margin-top: 8px;" type="text" icon="el-icon-plus"
                     @click="addCreateTableField">添加字段</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createTableVisible = false">取 消</el-button>
        <el-button type="primary" :loading="createTableLoading" @click="handleCreateTable">新增数据表</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {orderSource, orderWorkForm} from "@/api/dashboard";
import {
  feishuOrderSourceSyncConfig,
  saveFeishuOrderSourceSyncConfig,
  feishuSyncOrderSource,
  feishuOrderWorkFormSyncConfig,
  saveFeishuOrderWorkFormSyncConfig,
  feishuSyncOrderWorkForm,
  feishuCreateTable
} from "@/api/feishu";
import {copyToClipboard} from "@/utils/security";
import SummaryExportLink from "@/components/summary/ExportLink.vue";

// 两个维度的同步配置（共用同一套同步弹窗，按 scope 区分接口）
const SYNC_SCOPES = {
  order_source: {
    label: '广告主类型',
    entity: '广告主类型',
    getConfig: feishuOrderSourceSyncConfig,
    saveConfig: saveFeishuOrderSourceSyncConfig,
    sync: feishuSyncOrderSource
  },
  order_work_form: {
    label: '合作形式',
    entity: '合作形式',
    getConfig: feishuOrderWorkFormSyncConfig,
    saveConfig: saveFeishuOrderWorkFormSyncConfig,
    sync: feishuSyncOrderWorkForm
  }
}

export default {
  name: "SummaryOrder",
  components: {SummaryExportLink},
  inject: ['condition'],
  data() {
    return {
      queryOrderSourceOrder: '',
      queryOrderSourceProp: '',
      queryOrderWorkFormOrder: '',
      queryOrderWorkFormProp: '',
      dataOrderSource: [],
      dataOrderWorkForm: [],
      total_count: 0,
      total_money: 0,
      // 同步飞书（两个维度共用一套弹窗，syncScope 区分）
      syncScope: 'order_source',
      dialogSyncVisible: false,
      syncLoading: false,
      fieldTypeOptions: [
        {value: 1, label: '文本'},
        {value: 2, label: '数字'},
        {value: 3, label: '单选'},
        {value: 5, label: '日期'},
        {value: 7, label: '复选框'}
      ],
      syncForm: {app_token: '', table_id: '', mode: 'append', fields: []},
      createTableVisible: false,
      createTableLoading: false,
      createTableForm: {app_token: '', name: '', default_view_name: '', fields: []},
      createBatchJsonVisible: false,
      createBatchJson: '',
    }
  },
  computed: {
    // 当前同步维度的名称（用于弹窗标题/提示）
    syncScopeLabel() {
      const scope = SYNC_SCOPES[this.syncScope]
      return scope ? scope.label : ''
    }
  },
  created() {
    this.getData()
  },
  watch: {
    condition: {
      handler: function () {
        this.getData()
      },
      deep: true
    }
  },
  methods: {
    // 打开同步弹窗（scope: order_source | order_work_form）
    openSyncDialog(scope) {
      if (!SYNC_SCOPES[scope]) {
        return
      }
      this.syncScope = scope
      this.dialogSyncVisible = true
      // 拉取该维度的全局默认同步配置填充
      SYNC_SCOPES[scope].getConfig().then(res => {
        if (res && res.success) {
          this.syncForm.app_token = res.data.app_token || ''
          this.syncForm.table_id = res.data.table_id || ''
          this.syncForm.mode = res.data.mode || 'append'
          this.syncForm.fields = (res.data.fields || []).map(f => ({...f}))
        }
      })
    },
    buildSyncPayload() {
      return {
        app_token: this.syncForm.app_token,
        table_id: this.syncForm.table_id,
        mode: this.syncForm.mode,
        fields: (this.syncForm.fields || []).map(f => ({
          field: f.field,
          name: f.name,
          type: f.type,
          enabled: !!f.enabled
        }))
      }
    },
    handleSaveSyncConfig() {
      const scope = SYNC_SCOPES[this.syncScope]
      if (!scope) {
        return
      }
      if (!this.syncForm.app_token || !this.syncForm.table_id) {
        this.$message.warning('请填写多维表格 App Token 和数据表 ID')
        return
      }
      scope.saveConfig(this.buildSyncPayload()).then(res => {
        if (res && res.success) {
          this.$message.success('已保存为全局默认同步配置')
        }
      })
    },
    handleSyncData() {
      const scope = SYNC_SCOPES[this.syncScope]
      if (!scope) {
        return
      }
      if (!this.syncForm.app_token || !this.syncForm.table_id) {
        this.$message.warning('请填写多维表格 App Token 和数据表 ID')
        return
      }
      this.syncLoading = true
      const payload = this.buildSyncPayload()
      payload.year = this.condition.year
      payload.month = this.condition.month
      payload.organization_id = this.condition.organization_id || ''
      scope.sync(payload).then(res => {
        this.syncLoading = false
        if (res && res.success) {
          this.$message.success(`同步成功：共 ${res.data.records || 0} 条${scope.entity}数据，新增 ${res.data.created || 0} 条记录`)
          this.dialogSyncVisible = false
        }
      }).catch(() => {
        this.syncLoading = false
      })
    },
    openCreateTableDialog() {
      // 用当前填写的 app_token 预填，免去重复输入
      this.createTableForm.app_token = this.syncForm.app_token || ''
      this.createTableVisible = true
    },
    // 解析批量粘贴的 JSON（必须是数组）
    parseBatchFieldJson(str) {
      if (!str || !str.trim()) {
        this.$message.warning('请先粘贴 JSON 内容')
        return null
      }
      let parsed
      try {
        parsed = JSON.parse(str)
      } catch (e) {
        this.$message.error('不是合法的 JSON，请检查格式')
        return null
      }
      if (!Array.isArray(parsed)) {
        this.$message.error('需为 JSON 数组，如 [{...},{...}]')
        return null
      }
      return parsed
    },
    // 新增数据表弹窗：批量 JSON 生成字段（一次性追加多行）
    applyCreateBatchJson() {
      const parsed = this.parseBatchFieldJson(this.createBatchJson)
      if (!parsed) {
        return
      }
      const rows = parsed.map(item => ({
        field_name: item.field_name || '',
        type: item.type || 1
      }))
      this.createTableForm.fields.push(...rows)
      this.$message.success(`已批量生成 ${rows.length} 个字段`)
      this.createBatchJson = ''
      this.createBatchJsonVisible = false
    },
    // 同步弹窗：把已启用且有列名的字段导出为飞书多维表格字段 JSON（[{field_name,type}]），供「新增数据表」建列
    copySyncFieldsAsBitableJson() {
      const rows = (this.syncForm.fields || [])
        .filter(item => item.enabled !== false && (item.name || '').trim())
        .map(item => ({
          field_name: (item.name || '').trim(),
          type: item.type || 1
        }))
      if (!rows.length) {
        this.$message.warning('暂无已启用的同步字段可复制')
        return
      }
      copyToClipboard(JSON.stringify(rows)).then(() => {
        this.$message.success(`已复制 ${rows.length} 个飞书多维表格字段的 JSON 到剪贴板`)
      })
    },
    addCreateTableField() {
      this.createTableForm.fields.push({field_name: '', type: 1})
    },
    removeCreateTableField(index) {
      this.createTableForm.fields.splice(index, 1)
    },
    handleCreateTable() {
      if (!this.createTableForm.app_token) {
        this.$message.warning('请填写多维表格 App Token')
        return
      }
      if (!this.createTableForm.name) {
        this.$message.warning('请填写表名称')
        return
      }
      const payload = {
        app_token: this.createTableForm.app_token,
        name: this.createTableForm.name,
        default_view_name: this.createTableForm.default_view_name,
        fields: this.createTableForm.fields.filter(item =>
          item.field_name !== null && item.field_name !== '' && item.field_name !== undefined)
      }
      this.createTableLoading = true
      feishuCreateTable(payload).then(res => {
        this.createTableLoading = false
        if (res && res.success) {
          this.createTableVisible = false
          // 新增成功，把新数据表 ID 回填到同步表单
          if (res.data && res.data.table_id) {
            this.syncForm.table_id = res.data.table_id
          }
          this.$message.success('新增数据表成功，已回填数据表 ID')
        }
      }).catch(() => {
        this.createTableLoading = false
      })
    },
    // 处理搜索条件
    handleSearchConditionSource() {
      let condition = {queryOrder: this.queryOrderSourceOrder, queryProp: this.queryOrderSourceProp}
      condition = {...condition, ...this.condition}
      return condition
    },
    // 处理搜索条件
    handleSearchConditionWorkForm() {
      let condition = {queryOrder: this.queryOrderWorkFormOrder, queryProp: this.queryOrderWorkFormProp}
      condition = {...condition, ...this.condition}
      return condition
    },
    getOrderSource() {
      this.dataOrderSource = []
      const searchCondition = this.handleSearchConditionSource()
      orderSource(searchCondition).then(res => {
        this.dataOrderSource = res.model.data;
        this.total_count = res.model.total_count
        this.total_money = res.model.total_money
      })
    },
    getOrderWorkForm() {
      this.dataOrderWorkForm = []
      const searchCondition = this.handleSearchConditionWorkForm()
      orderWorkForm(searchCondition).then(res => {
        this.dataOrderWorkForm = res.model.data;
        this.total_count = res.model.total_count
        this.total_money = res.model.total_money
      })
    },
    getData() {
      this.getOrderSource()
      this.getOrderWorkForm()
    },
    sortOrderSourceChange({prop, order}) {
      this.queryOrderSourceOrder = order === "descending" ? 'desc' : 'asc'
      this.queryOrderSourceProp = prop
      this.getOrderSource()
    },
    sortOrderWorkFormChange({prop, order}) {
      this.queryOrderWorkFormOrder = order === "descending" ? 'desc' : 'asc'
      this.queryOrderWorkFormProp = prop
      this.getOrderWorkForm()
    },
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计:'
          return
        }
        if (['order_money', 'order_percent_money', 'customer_count', 'customer_percent_count', 'order_count', 'order_percent_count'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          switch (column.property) {
            case "order_money":
              sums[index] = '￥' + this.gFunc.numberFormat(sums[index]);
              break;
            case "order_percent_money":
            case "order_percent_count":
            case "customer_percent_count":
              sums[index] = this.gFunc.numberFormat(sums[index]) + "%";
              break;
          }
        }
      });
      return sums
    },
  }
}
</script>

<style scoped>
</style>
<style>
.caret-wrapper {
  width: 8px !important;
}

.box-card {
  margin-bottom: 10px;
}
</style>
